import * as React from 'react';
import style from './WFormFieldMultiselect.less';

interface WFormFieldMultiselectProps extends React.ClassAttributes<any> {
    options: Array<any>;
    hideSearch?: boolean;
    onChange: (options: Array<any>) => void;
}

interface WFormFieldMultiselectState {
    options: Array<any>;
    filterString: string;
}

export class WFormFieldMultiselect extends React.Component<WFormFieldMultiselectProps, WFormFieldMultiselectState>  {
    constructor(props: any) {
        super(props);
        this.toggleAll = this.toggleAll.bind(this);
        this.toggleValue = this.toggleValue.bind(this);
        this.state = {
            filterString: '',
            options: this.props.options
        };
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const strPreOpt = prevProps.options.map((o: any) => o.tid).join(',');
        const strThisOpt = this.props.options.map((o: any) => o.tid).join(',');
        if (strPreOpt !== strThisOpt) {
            this.setState({ options: this.props.options });
        }
    }

    render() {
        const { options } = this.state;
        const { hideSearch } = this.props;
        const checkedAll = options.every((o: any) => o.selected === true);
        const optFiltered = options.filter((o: any) => !this.state.filterString || this.state.filterString === '' ||
            (o.name + '').toLowerCase().indexOf(this.state.filterString.toLowerCase()) > -1);

        return <div className={style.wrapper}>
            {!hideSearch && <input
                style={{ fontSize: '0.9em' }}
                type='text'
                value={this.state.filterString}
                onChange={(evt: any) => this.setState({ filterString: evt.target.value })}
                placeholder='Suche'
            />}
            <div className={style.list}>
                {optFiltered.length > 0 ? optFiltered.map((o: any) => {
                    return <label key={'opt_' + o.tid} style={{ cursor: 'pointer' }}>
                        <input
                            type='checkbox'
                            value={o.tid}
                            checked={o.selected === true}
                            onChange={(evt: any) => {
                                const tid = evt.target.value;
                                const checked = evt.target.checked;
                                this.toggleValue(+tid, checked);
                            }}
                        /> {o.name}
                    </label>;
                }) : 'keine Datensätze vorhanden'}
            </div>
            <label style={{ cursor: 'pointer' }}>
                <input
                    type='checkbox'
                    onChange={this.toggleAll}
                    checked={checkedAll}
                /> Alle auswählen/entfernen
            </label>
        </div>;
    }

    toggleAll(evt: any) {
        const { options } = this.state;
        options.forEach((o: any) => o.selected = evt.target.checked);
        this.setState({ options });
        this.props.onChange(options);
    }

    toggleValue(tid: number, checked: boolean) {
        const { options } = this.state;
        const idx = options.findIndex((o: any) => o.tid === tid);
        if (idx !== -1) {
            options[idx].selected = checked;
            this.setState({ options });
            this.props.onChange(options);
        }
    }
}
